export const state = {
  
    token: localStorage.getItem("token") || "",
  };

export const getters = {
 
    gettoken(state){
       return state.token;
    }
  };
  export const mutations = {
      // NOT: Bu mutation tetiklendiğinde store.subscribe aracılığıyla
      // routeAndMenu/clearRoutes ve routeAndMenu/clearMenus otomatik çalışır.
      // Detay için store.js'e bakınız.
      SET_TOKEN(state, token) {
      state.token = token || "";
      if (state.token) localStorage.setItem("token", state.token);
      else localStorage.removeItem("token");
    },
  };
   export const actions = {
    setToken({ commit }, token) {
      commit("SET_TOKEN", token);
    },
    clearToken({ commit }) {
      commit("SET_TOKEN", "");
    }, 
  };